import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const PastWinner = () => {
  const [pastWinner, setPastWinner] = useState([]);
  const [error, setError] = useState("");
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    GetPastWinnersDetails();
  }, []);

  const GetPastWinnersDetails = async () => {
    setPageLoading(true);
    try {
      const response = await fetch(
        `${apiBaseURL}/api/IPLContestWatcho/GetPastWinnersDetails?name=empty&pageNumber=1&pageSize=10`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response?.status}`);

      const data = await response?.json();
      if (data?.resultStatus === "Success") {
        setPastWinner(data?.result);
      } else {
        setError(data?.message || "No winners found.");
      }
    } catch (error) {
      console.error("Error fetching past winners:", error);
    } finally {
      setPageLoading(false);
    }
  };

  return (
    <div className="pastWinnerContainer mt-3">
      <h1 className="text-center">
        Past <span>Winner's</span>
      </h1>

      <div className="container mt-4">
        {pageLoading ? (
          <p className="text-center">Loading...</p>
        ) : error ? (
          <p className="text-center text-danger">{error}</p>
        ) : (
          <>
            {pastWinner?.length === 0 ? (
              <h6 className="text-center">No past winners found.</h6>
            ) : (
              <OwlCarousel
                className="owl-theme"
                responsive={{
                  0: { items: 1 },
                  768: { items: 2 },
                  1024: { items: 4 },
                }}
                margin={20}
                nav
                dots={false}
              >
                {pastWinner.map((item, index) => (
                  <Card
                    className="p-2 bg-dark border-0 customCard"
                    orientation="horizontal"
                    size="lg"
                    key={index}
                    variant="outlined"
                  >
                    <Box sx={{ whiteSpace: "nowrap", mx: 1 }}>
                      <Typography
                        fontWeight={400}
                        textColor={"#ffffff"}
                        textTransform={"uppercase"}
                        level="title-md"
                      >
                        Winning Amount -{" "}
                        <span className="font-weight-bold">
                          ₹ {item?.winningAmt}
                        </span>
                      </Typography>
                      <Typography
                        textTransform={"uppercase"}
                        fontSize={16}
                        textColor={"#ffffff"}
                        fontWeight={"600"}
                        lineHeight={"25px"}
                        level="body-sm"
                      >
                        {item?.winnerName || "Unknown"}
                      </Typography>
                      <Typography
                        fontSize={14}
                        textColor={"#ffffff"}
                        lineHeight={"30px"}
                        level="body-sm"
                      >
                        {item?.maskedMobileNo}
                      </Typography>
                    </Box>
                  </Card>
                ))}
              </OwlCarousel>
            )}
          </>
        )}

        {pastWinner.length ? (
          <div className="text-center mt-4">
            <Link to="/PastWinner" className="viewAll btn">
              View All
            </Link>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
